import type { PresentationIsEmptyProps } from '../../../..'

export default function isEmpty(_props: PresentationIsEmptyProps) {
  return false
}
